import PrintShell, { PrintRow, PrintSectionHeader, PrintTextBlock } from '../../../components/print/PrintShell';

export default function AttendancePrintTemplate({ attendance: a }) {
  if (!a) return null;
  return (
    <PrintShell printClass="attendance-print-only" formTitle="MASS ATTENDANCE">
      <PrintSectionHeader title="Attendance" />
      <PrintRow fields={[
        { label: 'Mass Date', value: a.date },
        { label: 'Attendance Count', value: a.attendance },
      ]} />
      {a.info && <PrintTextBlock label="Notes" value={a.info} />}
    </PrintShell>
  );
}
